// extracted by mini-css-extract-plugin
export var component = "IndentedContent-module--component--7629b";
export var content = "IndentedContent-module--content--24155";
export var desktopOnly = "IndentedContent-module--desktopOnly--f12f5";
export var fadePop = "IndentedContent-module--fade-pop--3fe0f";
export var greyBg = "IndentedContent-module--greyBg--3bf9c";
export var growHeightIn = "IndentedContent-module--grow-height-in--3594a";
export var leftCol = "IndentedContent-module--leftCol--1c156";
export var rightCol = "IndentedContent-module--rightCol--58b05";
export var wrapper = "IndentedContent-module--wrapper--69d0e";